import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import * as parse from 'modules/parse'

class LargeQuote extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  returnDescription(description) {
    return (
      <ol className="large-quote-description">
        {
          description.map((el, i) => {
            return <li key={i} className="fade-in"><p>{el}</p></li>
          })
        }
      </ol>
    )
  }
  render() {
    let data, title, subTitle, description, quote1, quote2, author, source

    if (this.state && this.state.data) {
      data = this.state.data
      title = data.title
      subTitle = data.subTitle.text
      if (data.subTitle.editStyle) { subTitle = parse.addSpaces(subTitle)}
      quote1 = data.quote1.text
      if (data.quote1.editStyle) { quote1 = parse.parseContent(quote1, data.quote1.words, data.quote1.style ) }
      quote2 = data.quote2.text
      if (data.quote2.editStyle) { quote2 = parse.parseContent(quote2, data.quote2.words, data.quote2.style) }
      if (data.description) { description = data.description }
      author = data.author,
      source = data.source
    }

    return (
      <div>
        <section className="main-grid center">
          <ul className="grid group">
            <li className="grid-small">
              <h3 className="fade-in">{title}</h3>
              <h3 className="sectra-light fade-in large-quote-subtitle"><em>{subTitle}</em></h3>
              { description && this.returnDescription(description) }
            </li>

            <li className="grid-large inner-left fade-in-slow">
              <h1><span>{'\"'}</span>{quote1}</h1>
            </li>
          </ul>
        </section>

        <section className="main-split group">
          <div className="main-split-left"></div>
          <div className="main-split-right fade-in-slow">
            <h1>{quote2}<span>{'\"'}</span></h1>
            <h3>— {author}</h3>
            <h3 className="sectra fade-in-slow">{source}</h3>
          </div>
        </section>
    </div>
    )
  }
}
LargeQuote.contextTypes = {
}
LargeQuote.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(LargeQuote)



// WEBPACK FOOTER //
// ./src/components/Utils/LargeQuote.js